import axios from 'axios';
import router from 'src/router/index'

export function getShareInfo(type, title, desc, img) {
  // var locationUrl = window.location.href
  // axios.get('https://www.itdks.com/Home/Mobile/shareInfo?url=' + locationUrl.split("#")[0]).then(function(res){
  //   // axios.get('http://www.itdks.com/Api/Banner/getBanner?use_type=1'.then(function(res){
  //   if (res.status === 200) {
  //     let appId = res.data.appId;
  //     let nonceStr = res.data.nonceStr;
  //     let signature = res.data.signature;
  //     let timestamp = res.data.timestamp;
  //     var item = router.currentRoute
  //     var params = item.query
  //     params.path = item.path
  //     wx.config({
  //       debug: false,
  //       appId: appId,
  //       timestamp: timestamp,
  //       nonceStr: nonceStr,
  //       signature: signature,
  //       jsApiList: [
  //       'onMenuShareTimeline',
  //       'onMenuShareAppMessage',
  //       'onMenuShareQQ',
  //       'onMenuShareWeibo'
  //       ]
  //     });
  //     wx.ready(function() {
  //       let shareData = {}
  //       if (type) {
  //         shareData = {
  //           title: title,
  //           desc: desc,
  //           link: 'http://m.itdks.com' + '?pathParams=' + encodeURIComponent(JSON.stringify(params)),
  //           imgUrl: img
  //         }
  //       } else {
  //         shareData = {
  //           link: 'http://m.itdks.com' + '?pathParams=' + encodeURIComponent(JSON.stringify(params))
  //         }
  //       }
  //       wx.onMenuShareAppMessage(shareData);
  //       wx.onMenuShareTimeline(shareData);
  //       wx.onMenuShareQQ(shareData);
  //       wx.onMenuShareWeibo(shareData);
  //     });
  //   }
  // })
}

// export function getShareInfo(type, title, desc, img) {
//   var locationUrl = window.location.href
//     axios.get('http://www.itdks.com/api/share/getShareInfo?targetType=meeting&targetId=2897').then(function(res){
//     if (res.status === 200) {
//       console.log('进来了');
//     }
//   })
// };

// export function getShareInfo22() {
//   var locationUrl = window.location.href
//     axios.get('https://www.itdks.com/Home/Mobile/shareInfo').then(function(res){
//     if (res.status === 200) {
//       console.log('进来了22');
//     }
//   })
// }

// var storage={

//   // 存储数据(字符串)
//   set(key,value){
//     localStorage.setItem(key,value);
//   },

//   // 存储数据(对象)
//   set2(key,value){
//     localStorage.setItem(key,JSON.stringify(value));
//   },

//   // 取出数据
//   get(key){
//     // return JSON.parse(localStorage.getItem(key));
//     return localStorage.getItem(key);
//   },

//   // 删除数据
//   remove(key){
//     localStorage.removeItem(key);
//   }

// }

// 暴露给外部访问
// export default storage;



// var pw='',
// isWeiXin='',
// sq_uid=null,
// nick_name=null,
// ip='',
// current_url=null,
// source_url=null;

// 获取状态（是否微信登录以及是否已授权）
// export function get_uid(){
//   current_url=window.location.href;
//   if(storage.get('source_url')&&storage.get('source_url')!=''){
//     source_url=storage.get('source_url');
//   }
//   storage.set('source_url',window.location.href);
//   // if(source_url==source_url){
//   //   source_url=storage.get('source_url');
//   // }
//   if(storage.get('uid')&&storage.get('uid')!=''&&storage.get('uid')!='null'){
//     sq_uid=storage.get('uid');
//     nick_name=storage.get('nick_name');
//   }
//   else if(router.currentRoute.query.uid&&router.currentRoute.query.uid!=''){
//     sq_uid=router.currentRoute.query.uid;
//     nick_name=router.currentRoute.query.nick_name;
//   }
//   storage.set('uid',sq_uid);
//   sq_uid=storage.get('uid');
//   storage.set('nick_name',nick_name);
//   nick_name=storage.get('nick_name');
//   // alert(current_url+'+'+sq_uid+'+'+nick_name);
//   axios.get('http://www.itdks.com/Home/My/getWxUid').then(res => {
//     // console.log(router.currentRoute);
//     if(res.data.status==1){
//       isWeiXin=res.data.data.isWeiXin;
//       ip=res.data.data.ip;
//       send_nick_name(sq_uid,nick_name,current_url,source_url);
//       // test_wechat(isWeiXin,sq_uid);
//       setInterval(() => {
//         test_wechat(isWeiXin,sq_uid);
//       },2000);
//     }
//     else{
//       console.log(res.data.msg);
//     }
//   })
// }

// 跳转到微信授权页面
// export function test_wechat(isWeiXin,sq_uid) {
//   if(isWeiXin==true){
//     if(sq_uid&&sq_uid!=''&&sq_uid!='null'){
//       return
//     }
//     else{
//       let locationUrl = window.location.href;
//       let newurlProbably=locationUrl.replace(/http:\/\/[^\/]*/, "");
//       let newurl=setBase(newurlProbably);
//       // let jiami_url='http://www.itdks.com/Home/auth/authBack?params='+newurl;
//       let jiami_url='http://www.itdks.com/Home/auth/authBackTest?params='+newurl;
//       let weixin_encodeURI='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdb7ae4d519952e9a&redirect_uri='+jiami_url+'&response_type=code&scope=snsapi_userinfo&state=1&component_appid=wx94aa7c42919766bb#wechat_redirect'; 
//       window.location.href=weixin_encodeURI;
//     }
//   }
//   else{
//     return
//   }
// }

// 发送name和url等数据给接口
// export function send_nick_name(sq_uid,nick_name,current_url,source_url){
//   axios.post('http://www.itdks.com/Home/Statistics/addUserTodayView', {
//     uid:sq_uid,
//     nick_name:nick_name,
//     current_url:current_url,
//     source_url:source_url,
//   })
//   .then(function (response) {
//     console.log('请求成功');
//   })
//   .catch(function (error) {
//     console.log('请求失败');
//   });
// }

// 调用加密函数
// export function setBase(url){
//   let Base64 = require("js-base64").Base64;
//   let wx_state = Base64.encode(url);
//   return wx_state;
// }



// WEBPACK FOOTER //
// ./src/assets/js/common.js